window.FastClick = require('fastclick');
require('lazyload');
require('fancybox')(window.$);
window.notie = require('corner-notie');

require('./utils');
require('./motion');
require('./affix');
require('./pisces')();
require('./scrollspy');
require('./post-details')();
require('./bootstrap');
require('./evanyou');
require('./leancloud')();
require('./share')();
require('./scroll');
require('./since');
require('./title');
require('./type');
require('./kanban');
require('./mix');
require('./clipboard');
require('./pjax');
require('./online');
require('./search');



// WEBPACK FOOTER //
// ./src/index.js